import useUploadFiles from 'api/hooks/useUploadFiles';
import type { UploadHubListItem } from 'api/hooks/useUploadFiles';
import ModalComponent from 'components/Common/Modal';
import createNotification from 'components/Settings/Utilities/CreateNotification';
import { useState } from 'react';

interface UploadHubDeleteModalProps {
  openState: {
    isOpen: boolean;
    setIsOpen: (value: boolean) => void;
  };
  itemIdState: {
    itemId: string | number | null;
    setItemId: (value: string | number | null) => void;
  };
  filesState?: {
    files: UploadHubListItem[];
    setFiles: (value: UploadHubListItem[]) => void;
  };
  onDeleted?: () => void;
}

const UploadHubDeleteModal = (props: UploadHubDeleteModalProps) => {
  const { openState, itemIdState, filesState, onDeleted } = props ?? {};
  const { itemId, setItemId } = itemIdState ?? {};
  const { isOpen, setIsOpen } = openState ?? {};
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const { deleteItemFromUploadHub } = useUploadFiles();

  const deleteItem = async () => {
    try {
      setIsLoading(true);
      const { status } = await deleteItemFromUploadHub({ id: itemId ?? '' });
      if (status === 200) {
        if (filesState) {
          let newFiles = [...filesState.files];
          let position = newFiles.findIndex((item) => item?.id === itemId);
          if (position >= 0) {
            newFiles.splice(position, 1);
          }
          filesState.setFiles(newFiles);
        }
        setIsLoading(false);
        setIsOpen(false);
        createNotification('success', 'File deleted successfully');
        onDeleted?.();
      } else {
        setIsLoading(false);
      }
    } catch {
      setIsLoading(false);
    }
  };
  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      maxWidth={558}
      overlayClassName={'react-modal-overlay modal-close-position-adjustment'}
      onAfterClose={() => setItemId(null)}
    >
      <div className='p-5 text-center'>
        <p className='title-h5-m-bold'>Are you sure you want to delete this file?</p>
        <p className='mb-4 light-80-text'>
          This cannot be undone, and any links to this file which have already been shared will no longer work
        </p>
        <button
          className='rounded-pill general-button danger-button px-4 py-2'
          disabled={isLoading}
          onClick={deleteItem}
        >
          {isLoading && <i className='fas fa-spinner fa-spin d-inline-block-centered mr-2' />}
          Delete file
        </button>
      </div>
    </ModalComponent>
  );
};

export default UploadHubDeleteModal;
